import React from 'react';
import useVodPlayer from './_hooks/use-vod-player';
import VodPlayerScreen from './vod-player-screen/vod-player-screen';
import LivePlayerScreen from './live-player-screen/live-player-screen';
import PlayerControlsProvider from '../player-controls/player-controls-context';
import { StreamType } from '@smart-tv/typings/content';

export const StreamPlayer: React.FC = () => {
  const { isPlaying, streamOptions } = useVodPlayer();
  const streamType = streamOptions?.streamType;

  const isLiveStream = streamType === StreamType.LiveStream || streamType === StreamType.StartOver;

  if (!isPlaying) return null;

  return (
    <PlayerControlsProvider>
      {isLiveStream ? <LivePlayerScreen /> : <VodPlayerScreen />}
    </PlayerControlsProvider>
  );
};

export default React.memo(StreamPlayer);
